import { Component } from "../../core/Component";
export class CaptchaComponent extends Component {
  RECAPTCHA_INVISIBLE_TYPE = 2;
  RECAPTCHA_CHECK_TYPE = 1;
  // static className = ["qform-captcha"];
  constructor($root, options) {
    $root.$el.classList.remove("qform-row");
    $root.$el.classList.add("qform-captcha");
    super($root, options);
    $root.id(`${options.formId}_${options.formIndex}_recaptcha`);
    this.idClose = `${options.formId}_${options.formIndex}_recaptcha_close`;
    this.idContinue = `${options.formId}_${options.formIndex}_recaptcha_continue`;
    this.idCaptcha = `${options.formId}_${options.formIndex}_g-recaptcha`;
    this.boxId = `${options.formId}_${options.formIndex}_box`;
    this.errorBoxId = `${options.formId}_${options.formIndex}error-box`;
    this.errorBoxTextId = `${options.formId}_${options.formIndex}error-box_message`;
    this.captchaSitekey = options.captchaSitekey;
    this.recaptchaVersion = options.recaptchaVersion;
    this.recaptchaType = options.recaptchaMode;
    this.captchaWidgetObj = null;
    this.messages = options.messages;
  }
  toHTML() {
    if (this.recaptchaVersion === 2 && this.recaptchaType === this.RECAPTCHA_INVISIBLE_TYPE) {
      return `<div id="${this.idCaptcha}" class="g-recaptcha"
        data-sitekey="${this.captchaSitekey}"
        data-callback="onQformCompleteCaptcha"
        data-size="invisible">
     </div>`;
    }
    return `
    <div class="qform-captcha">
      <!-- .open | <empty> -->
      <div class="qform-captcha__box" id="${this.boxId}">
        <div class="qform-captcha__box-content" id="${this.idCaptcha}"></div>
        <div class="qform-captcha__error-box" id="${this.errorBoxId}">
          <div class="qform-captcha__error-box_message" id="${this.errorBoxTextId}"></div>
        </div>
        <div class="qform-captcha__box-actions">
          <div class="qform-captcha__box-actions__continue" id="${this.idContinue}">${this.messages.continueText}</div>
          <div class="qform-captcha__box-actions__close" id="${this.idClose}">${this.messages.buttonClose}</div>
        </div>
      </div>
    </div>
    `;
  }
  captchaShow() {
    if (typeof grecaptcha !== "undefined") {
      if (this.recaptchaVersion === 2) {
        if (this.captchaWidgetObj !== null) {
          if (this.recaptchaType === this.RECAPTCHA_INVISIBLE_TYPE) {
            window.onQformCompleteCaptcha = this.onCompleteCaptcha.bind(this);
            grecaptcha.execute(this.captchaWidgetObj);
          } else {
            this.$box.classList.add("open");
          }
        }
      } else {
        grecaptcha.execute(this.captchaSitekey).then(token => {
          this.$emit("Submit:sendForm", {
            token: token
          });
        }).catch(err => {
          console.error(err);
        });
      }
    } else {
      alert(this.messages.captchaIncorrect || 'Captacha error');
    }
  }
  onloadCaptcha() {
    let interval = setInterval(() => {
      if (typeof grecaptcha !== "undefined" && grecaptcha.render) {
        if (this.captchaWidgetObj === null) {
          this.captchaWidgetObj = grecaptcha.render(this.$boxCaptcha, {
            sitekey: this.captchaSitekey
          });
        }
        clearInterval(interval);
      }
    }, 200);
  }
  onClickContinue(event) {
    event.stopPropagation();
    let token = grecaptcha.getResponse(this.captchaWidgetObj);
    if (token.length > 5) {
      this.setMessageValid();
      this.$emit("Submit:sendForm", {
        token
      });
      this.captchaHide();
    } else {
      this.setMessageValid(this.messages.captchaError);
    }
  }
  onCompleteCaptcha() {
    let token = grecaptcha.getResponse(this.captchaWidgetObj);
    if (token.length > 5) {
      this.setMessageValid();
      this.$emit("Submit:sendForm", {
        token
      });
    }
  }
  captchaHide() {
    let event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    event ? event.stopPropagation() : null;
    this.$box.classList.contains("open") ? this.$box.classList.remove("open") : null;
  }
  init() {
    this.onloadCaptcha();
    this.$subscribe("QForm:captchaShow", this.captchaShow.bind(this));
    this.$subscribe("QForm:onloadCaptcha", this.onloadCaptcha.bind(this));
    this.$boxCaptcha = this.$root.$el.querySelector(`#${this.idCaptcha}`);
    this.$box = this.$root.$el.querySelector(`#${this.boxId}`);
    this.$btnClose = this.$root.$el.querySelector(`#${this.idClose}`);
    this.$btnContinue = this.$root.$el.querySelector(`#${this.idContinue}`);
    this.$errorBox = this.$root.$el.querySelector(`#${this.errorBoxId}`);
    this.$errorBoxText = this.$root.$el.querySelector(`#${this.errorBoxTextId}`);
    if (this.recaptchaType !== this.RECAPTCHA_INVISIBLE_TYPE) {
      this.listeners = [{
        eventName: "click",
        method: "captchaHide",
        el: this.$btnClose
      }, {
        eventName: "click",
        method: "onClickContinue",
        el: this.$btnContinue
      }];
    }
    super.init();
  }
}